import { render } from "./rsvp-form.vue?vue&type=template&id=dbd133b4&scoped=true"
import script from "./rsvp-form.vue?vue&type=script&lang=js"
export * from "./rsvp-form.vue?vue&type=script&lang=js"

import "./rsvp-form.vue?vue&type=style&index=0&id=dbd133b4&scoped=true&lang=scss"

import exportComponent from "/Users/tvanderlin@ideo.com/Dev/davis-getting-married/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd133b4"]])

export default __exports__